export const IS_KIDS = process.env.IS_KIDS == 1;